/* eslint-disable */
const axios = require('axios');
import convertToJson from './convertToJson';

export default async function fetchLocations(slug) {
  let data;
  let params;

  if (slug) {
    params = 'location-slug=' + slug;
  } else {
    params = 'get-all-locations';
  }

  var config = {
    method: 'get',
    url: '/api/index.php?' + params,
  };

  const result = await axios(config);
  let locations;
  if (!slug) {
    convertToJson(result.data);
    locations = result.data;
  } else {
    console.log(result);
    locations = result.data.location;
  }

  if (!slug) {
    return locations.filter(location => location.visible);
  } else {
    convertToJson(locations);
    return locations;
  }
}
